window.addEventListener('scroll', ()=>{
  document.body.setAttribute('data-scrolled', 'true');
});